import Loadable from "react-loadable";

import { Loading } from "../../common/navigation";

const Absences = Loadable({
  loader: () => import("./components/absences"),
  loading: Loading,
});

const NotifyAbsences = Loadable({
  loader: () => import("./components/notify-absence"),
  loading: Loading,
});

const EditAbsence = Loadable({
  loader: () => import("./components/edit-absence-reason"),
  loading: Loading,
});

const ExtendedLeave = Loadable({
  loader: () => import("./components/extended-leave"),
  loading: Loading,
});

export const routes = [
  {
    path: "/absences",
    exact: true,
    name: "absences",
    component: Absences,
    // "permission": {
    //   "contactype": [
    //     "affiliate"
    //   ],
    //   "group": [
    //     "Staff Carers"
    //   ]
    // },
  },
  {
    path: "/absences/notify-absence/:id",
    exact: true,
    name: "Notify Absences",
    component: NotifyAbsences,
    // "permission": {
    //   "contactype": [
    //     "affiliate"
    //   ],
    //   "group": [
    //     "Staff Carers"
    //   ]
    // },
  },
  {
    path: "/absences/extended-leave",
    exact: true,
    name: "Extended Leave",
    component: ExtendedLeave,
  },
  {
    path: "/absences/extended-leave/:id",
    exact: true,
    name: "Notify Extended Leave",
    component: NotifyAbsences,
  },
  {
    path: "/absences/edit-absence-reason/:stduentNumber/:id",
    exact: true,
    name: "Edit Absence Reason",
    component: EditAbsence,
  },
];
